import React, { useEffect, useState } from "react";
import AxiosInstance from "../authorization/AxiosInstance";

const DEFAULTS = {
  stat1Value: "16", stat1Label: "Intervention",
  stat2Value: "400", stat2Label: "LGAs Covered",
  stat3Value: "40,000+", stat3Label: "Beneficiaries",
  stat4Value: "50+", stat4Label: "Partners",
};

const STAT_KEYS = [
  { valueKey: "stat1Value", labelKey: "stat1Label" },
  { valueKey: "stat2Value", labelKey: "stat2Label" },
  { valueKey: "stat3Value", labelKey: "stat3Label" },
  { valueKey: "stat4Value", labelKey: "stat4Label" },
];

const cls = "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400";

export default function StatsAdmin() {
  const [form, setForm] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    AxiosInstance.get("/stats-config")
      .then((r) => setForm({ ...DEFAULTS, ...r.data }))
      .catch(() => setError("Failed to load stats config"))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true); setError(null); setSuccess(false);
    try {
      await AxiosInstance.patch("/stats-config", form);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (e) {
      setError(e?.response?.data?.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-gray-400 text-sm">Loading…</div>;

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-6">Stats Banner</h2>

      <div className="bg-white rounded-xl shadow p-6 max-w-xl">
        {error && <div className="mb-4 text-red-600 text-sm">{error}</div>}
        {success && <div className="mb-4 text-green-600 text-sm font-medium">Saved successfully.</div>}

        <div className="space-y-5">
          {STAT_KEYS.map(({ valueKey, labelKey }, i) => (
            <div key={i} className="border border-gray-100 rounded-lg p-4 bg-gray-50">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">
                Stat {i + 1}
              </p>
              <div className="flex gap-3">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Value</label>
                  <input name={valueKey} value={form[valueKey]} onChange={handleChange} className={cls} placeholder="e.g. 40,000+" />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Label</label>
                  <input name={labelKey} value={form[labelKey]} onChange={handleChange} className={cls} placeholder="e.g. Beneficiaries" />
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={handleSave}
          disabled={saving}
          className="mt-6 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-6 py-2 rounded-lg disabled:opacity-50"
        >
          {saving ? "Saving…" : "Save Changes"}
        </button>
      </div>
    </div>
  );
}
